import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const CheckNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            // eslint-disable-next-line max-len
            d='M20.2957 6.29484C20.6851 6.68429 20.6851 7.31572 20.2957 7.70517L9.00083 19L4.20626 14.2054C3.81666 13.8158 3.81666 13.1842 4.20626 12.7946C4.59552 12.4053 5.22652 12.4049 5.61626 12.7937L9.00083 16.17L18.8857 6.2945C19.2752 5.90536 19.9063 5.90551 20.2957 6.29484Z'
            fill='currentColor'
        />
    </svg>
));
